// extracted by mini-css-extract-plugin
export default {"frame":"ProfileImg_frame__VMH21","imgWrapper":"ProfileImg_imgWrapper__k1WI1","img":"ProfileImg_img__lbOX7","imgLayer":"ProfileImg_imgLayer__hl2AO"};